export default __webpack_public_path__ + "72c98c6.png";